export var SnapshotTypes;
(function (SnapshotTypes) {
    SnapshotTypes["pageview"] = "pageview";
    SnapshotTypes["sdk"] = "sdk";
    SnapshotTypes["webv1"] = "webv1";
    SnapshotTypes["webv2"] = "webv2";
    SnapshotTypes["ct"] = "ct";
})(SnapshotTypes || (SnapshotTypes = {}));
export var SnapshotMidZoneHeightCalculationStatus;
(function (SnapshotMidZoneHeightCalculationStatus) {
    SnapshotMidZoneHeightCalculationStatus["Pending"] = "pending";
    SnapshotMidZoneHeightCalculationStatus["Complete"] = "complete";
    SnapshotMidZoneHeightCalculationStatus["Failed"] = "failed";
})(SnapshotMidZoneHeightCalculationStatus || (SnapshotMidZoneHeightCalculationStatus = {}));
export const EXPORT_TYPE = 'export';
//# sourceMappingURL=snapshot-types.js.map